import * as React from "react"
import type { SVGProps } from "react"
const SvgPlusCircleFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 13v3q0 .42.29.71.29.3.71.29c.42-.01.52-.1.71-.29A1 1 0 0 0 13 16v-3h3q.42 0 .71-.29A1 1 0 0 0 17 12a1 1 0 0 0-.29-.71A1 1 0 0 0 16 11h-3V8a1 1 0 0 0-.29-.71A1 1 0 0 0 12 7a1 1 0 0 0-.71.29A1 1 0 0 0 11 8v3H8a1 1 0 0 0-.71.29A1 1 0 0 0 7 12a.97.97 0 0 0 1 1zm1 9a10 10 0 0 1-3.9-.79 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.17A10 10 0 0 1 2 12q0-2.07.79-3.9a10 10 0 0 1 2.14-3.17Q6.28 3.56 8.1 2.78A10 10 0 0 1 12 2q2.07 0 3.9.79a10 10 0 0 1 3.18 2.14q1.34 1.35 2.13 3.17A10 10 0 0 1 22 12a10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.18q-1.34 1.34-3.17 2.13A10 10 0 0 1 12 22" />
  </svg>
)
export default SvgPlusCircleFilled
